// Fichier db.js (ou tout autre nom de votre choix)

import Dexie from 'dexie';

const db = new Dexie('MaBaseDeDonnees');
db.version(1).stores({
  monTableau: 'id++,email,role,nomRestaurant,adresse,telephone,precision,description,plan,urlPlan,codePostal,nomGerant,prenomGerant,telephoneFix,telephonePortable,autreTelephone,emailGerant,nombreSalarier,commentaire,equipementAditionnelle,equipementWifi,remarque,login,password,ville,abonnement,change,nombrePersonne,statusPrixCarte,typeCuisines,regimeAlimentaires,quartiers,cadreAmbiances,payements,photos,serviceRestaurant,petitDejeuners,entrers,plats,desserts,boissons,prixMoyenne,menus,fermetureCongers,informations,promotions,reservationDirects,creneauPromos,parametragePromotions,sansOffres,offreDirects,promoSpecial,favoris,reservations,avis,notes,photoRestos,avisRestos,avisProduitServices,dateCreation',
});

export default db;

